import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import conciergeApiClient from "Services/Apis/Concierge/conciergeApiClient";

export const getConvertedPriceThunk = createAsyncThunk(
  "GetConvertedPrice/getConvertedPriceThunk",
  async (price, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile["custom:campaign_id"],
      catalogId: user.profile["custom:catalog_id"],
      participantId: user.profile["custom:participant_id"],
      username: user.profile.username || user.profile["custom:login"],
    };

    const config = {
      headers,
      params: { price },
    };

    const { data } = await conciergeApiClient.get(
      "Product/get-converted-price",
      config
    );

    return data;
  }
);

const initialState = {
  convertedPrice: undefined,
  isConvertedPriceLoading: false,
  convertedPriceHasErrors: false,
};

const GetConvertedPriceSlice = createSlice({
  name: "GetConvertedPrice",
  initialState,
  reducers: {
    resetConvertedPriceData: (state) => {
      state.convertedPrice = undefined;
      state.isConvertedPriceLoading = false;
      state.convertedPriceHasErrors = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConvertedPriceThunk.pending, (state) => {
      state.convertedPrice = undefined;
      state.isConvertedPriceLoading = true;
      state.convertedPriceHasErrors = false;
    });

    builder.addCase(getConvertedPriceThunk.fulfilled, (state, action) => {
      state.convertedPrice = action.payload;
      state.isConvertedPriceLoading = false;
      state.convertedPriceHasErrors = false;
    });

    builder.addCase(getConvertedPriceThunk.rejected, (state) => {
      state.convertedPrice = undefined;
      state.isConvertedPriceLoading = false;
      state.convertedPriceHasErrors = true;
    });
  },
});

export const { resetConvertedPriceData } = GetConvertedPriceSlice.actions;
export default GetConvertedPriceSlice.reducer;
